import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';

import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { RateNotesDialogComponent } from '@ruby/shared/dialogs/rate-notes/rate-notes.dialog';

@NgModule({
  declarations: [RateNotesDialogComponent],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatListModule
  ],
  exports: [RateNotesDialogComponent]
})
export class RateNotesDialogModule {}
